<main class="main-content">
  <div class="container">
    <h1 class="main-page-title">تماس با ما</h1>
    <div class="row align-items-center">
      <div class="col-12 col-md-6">
        <div class="ziraxi-box my-5">
          <div class="address-divider">
            <mat-icon class="blue" svgIcon="phone-call"></mat-icon>
            تماس با زیراکسی
          </div>
          <div class="row">
            <div class="col-5 address-title">پشتیبانی</div>
            <div class="col-7 address-content">
              <a href="tel:+982191691030">021-91691030</a>
            </div>
          </div>
          <div class="row">
            <div class="col-5 address-title">دفتر مرکزی</div>
            <div class="col-7 address-content">
              <a href="tel:+983133877389">031-33877389</a>
            </div>
          </div>
          <div class="row">
            <div class="col-5 address-title">پست الکترونیک</div>
            <div class="col-7 address-content">
              <a href="mailto:support@ziraxi.com">support@ziraxi.com</a>
            </div>
          </div>
          <div class="address-divider">
            <mat-icon class="blue" svgIcon="headphones-alt-2"></mat-icon>
            مشاوره اختصاصی
          </div>
          <div class="row">
            <div class="col-5 address-title">مشاور اختصاصی چاپ (رایگان)</div>
            <div class="col-7 address-content">
              <a href="tel:+989130861030" class="d-block phone-tag">0939-901 62 72</a>
            </div>
          </div>

          <div class="address-divider">
            <mat-icon class="blue" svgIcon="mail-check"></mat-icon>
            آدرس پستی
          </div>
          <div class="row">
            <div class="col-5 address-title">آدرس 1</div>
            <div class="col-7 address-content">تهران، قیطریه، محمودیان 1</div>
          </div>
          <div class="row">
            <div class="col-5 address-title">آدرس 2</div>
            <div class="col-7 address-content">
              اصفهان، خیابان امام خمینی، شهرک مهدیه
            </div>
          </div>
          <div class="row">
            <div class="col-5 address-title">کد پستی</div>
            <div class="col-7 address-content">8195815485</div>
          </div>
          <div class="address-divider">
            <mat-icon class="blue" svgIcon="message-circle-heart"></mat-icon>
            شبکه‌های اجتماعی
          </div>
          <div class="social-medias">
            <mat-icon class="blue-fill" svgIcon="pinterest"></mat-icon>
            <mat-icon class="blue-fill" svgIcon="linkedin"></mat-icon>
            <mat-icon class="blue-fill" svgIcon="instagram"></mat-icon>
            <mat-icon class="blue-fill" svgIcon="whatsapp"></mat-icon>
            <mat-icon class="blue-fill" svgIcon="telegram"></mat-icon>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="m-5">
          <img src="assets/image/contact-us.png" alt="contact-ziraxi" />
        </div>
      </div>
    </div>
    <div class="row align-items-center">
      <div class="col-12 col-md-6">
        <div class="m-5">
          <img src="assets/image/pages/aount-us-main.png" alt="about-ziraxi" />
        </div>
      </div>
      <div class="col-12 col-md-6">
        <div class="ziraxi-box my-5 thick">
          <div class="address-divider">درباره ما</div>
          <div class="address-content">
            زیراکسی، جایی است که شما می‌توانید پرینت ارزان و باکیفیت داشته
            باشید. سامانه چاپ آنلاین زیراکسی به شما این امکان را می‌دهد تا در هر
            کجای کشور که هستید، سفارش‌های خود را به‌آسانی ثبت کرده و در جریان هر
            مرحله از سفارش قرار بگیرید.
            <br />
            با استفاده از خدمات زیراکسی می‌توانید تا 80 درصد در هزینه‌های پرینت
            و چاپ خود صرفه‌جویی کنید و در کمترین زمان ممکن، سفارش‌های خود را
            تحویل بگیرید. ما به‌واسطه برخورداری از تیمی جوان و باتجربه، کیفیت
            تمام خدمات خود را تضمین کرده و تا رسیدن به بالاترین حد از رضایت، در
            کنار شما هستیم.
          </div>
        </div>
      </div>
    </div>
  </div>
</main>

<app-footer></app-footer>
